import { useCallback } from 'react';

import { Loader } from '@ui/components/Loader';

import {
  useClubCardQuery,
  useClubUploadLogoMutation,
  useClubUploadSponsorLogoMutation,
  useUpdateClubMutation,
} from '@features/club/api/hooks';
import { ClubInfoForm } from '@features/club/ui/ClubInfoForm/ClubInfoForm';

type Props = {
  clubId: string;
  disabled?: boolean;
};
export function ClubInfoFormWidget({ clubId, disabled }: Props) {
  const { data: club, refetch } = useClubCardQuery(clubId);
  const { mutateAsync: onSubmit } = useUpdateClubMutation(clubId);
  const { mutateAsync: onUploadLogo } = useClubUploadLogoMutation(clubId);
  const { mutateAsync: onUploadSponsorLogo } = useClubUploadSponsorLogoMutation(clubId);

  const handleUploadLogo = useCallback(
    async (formData: FormData) => {
      await onUploadLogo(formData);
      refetch();
    },
    [onUploadLogo, refetch],
  );

  const handleUploadSponsorLogo = useCallback(
    async (sponsorNumber: number, formData: FormData) => {
      await onUploadSponsorLogo({ sponsorNumber, formData });
      refetch();
    },
    [onUploadSponsorLogo, refetch],
  );

  if (!club) return <Loader centered />;

  return (
    <ClubInfoForm
      club={club}
      onSubmit={onSubmit}
      onUploadLogo={handleUploadLogo}
      onUploadSponsorLogo={handleUploadSponsorLogo}
      disabled={disabled}
    />
  );
}
